import { ComponentFactoryResolver, Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { NoDataMessageComponent } from '../components/no-data-message/no-data-message.component';

@Directive({
  selector: '[showWithNoDataMessage]',
})
export class ShowWithNoDataMessageDirective<T> {
  @Input() set showWithNoDataMessage(isVisible: boolean) {
    this.viewContainer.clear();

    if (isVisible) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      const factory = this.resolver.resolveComponentFactory(NoDataMessageComponent);
      this.viewContainer.createComponent(factory);
    }
  }

  constructor(
    private templateRef: TemplateRef<T>,
    private viewContainer: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
  ) {}
}
